import { NOTIFICATION_BROADCAST_TYPE } from "@/entities/notification-broadcast";
import { useEventBusListener } from "@/modules/event-bus";

import { useJobModuleActionRunning } from "./job-module-action-running.hook";

const JobModuleActionRunning = () => {
  const { runAction } = useJobModuleActionRunning();

  useEventBusListener(
    NOTIFICATION_BROADCAST_TYPE.JOB_MODULE_RUNNING,
    runAction
  );

  return <></>;
};

export default JobModuleActionRunning;
